import initTiltEffect from "./scripts/tiltAnimation";

initTiltEffect();
